import React, { useState } from 'react'

const DashboardFilter = ({shops, years, onSearch }) => {

  const [selectedShop, setSelectedShop] = useState("");
  const [selectedYear, setSelectedYear] = useState("");

    const handleSearch = () => {
    onSearch({
      shopId: selectedShop,
      year: selectedYear
    });
  };



  return (
               <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Select branch</label>
                  <select className="form-control selectpicker" value={selectedShop} onChange={(e) => setSelectedShop(e.target.value)}>
                    <option value="" disabled selected>
                      Select
                    </option>

                    {shops?.map((shop) => (
                      <option key={shop.id} value={shop.id}>
                        {shop.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
                <div className="col-md-3">
                   <div className="form-group">
                  <label>Select Year</label>
                  <select className="form-control selectpicker" value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
                    <option value="" disabled selected>
                      Select
                    </option>

                    {years?.map((year) => (
                      <option>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
                </div>
{/* 
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Data Type</label>
                    <select className="form-control selectpicker">
                      <option>Select</option>
                      <option>Day wise</option>
                      <option>Week wise</option>
                      <option>Month wise</option>
                    </select>
                  </div>
                </div> */}
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="exampleFormControlSelect1">&nbsp;</label>
                    <br />
                    <button href="#" className="btn btn-primary w-auto" onClick={handleSearch}>
                      <i className="fa fa-search"></i> Search
                    </button>
                  </div>
                </div>
              </div>
  )
}

export default DashboardFilter